import { Plan } from "@builder/types/Plan.type";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getAuthToken } from "jwt-storage-lib";

const PLAN_PATH = "subscriptions/subscription-operations";

export const planApi = createApi({
    reducerPath: "planApi",
    baseQuery: fetchBaseQuery({
        baseUrl: `${import.meta.env.VITE_URL_HUB_API}${PLAN_PATH}`,
        prepareHeaders: async headers => {
            const token = await getAuthToken();

            if (token) {
                headers.set("Authorization", `Bearer ${token}`);
            }

            return headers;
        }
    }),
    tagTypes: ["plan"],
    endpoints: builder => ({
        getAllPlans: builder.query<Plan[], string>({
            query: organizationId => `/plan/get-all/${organizationId}`,
            providesTags: ["plan"]
        })
    })
});

export const { useLazyGetAllPlansQuery } = planApi;
